import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const FileDownloadOutline = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 12 12'
    >
      <path
        d='M7 1L10 4V10C10 10.2652 9.89464 10.5196 9.70711 10.7071C9.51957 10.8946 9.26522 11 9 11H3C2.73478 11 2.48043 10.8946 2.29289 10.7071C2.10536 10.5196 2 10.2652 2 10V2C2 1.73478 2.10536 1.48043 2.29289 1.29289C2.48043 1.10536 2.73478 1 3 1H7ZM9 10V4.5H6.5V2H3V10H9ZM6 9.5L4 7.5H5.25V6H6.75V7.5H8L6 9.5Z'
        fill='#F8F8F8'
      />
    </SvgIcon>
  );
};
export default FileDownloadOutline;
